import {Tooltip} from '@mui/material'
import {Box, Loading, Skeleton, Typography} from '@viptech/react-components'
import {abbreviateNumber} from 'src/utilities/formatter'
import styled from 'styled-components'

type DashboardCountCardProps = {
  title: string
  value: number | undefined | string
  loading: boolean
  description: string
  icon: React.ReactNode
  refetching?: boolean
}

function DashboardCountCard({title, value, description, loading, refetching, icon}: DashboardCountCardProps) {
  return (
    <ResponsiveContainer
      position='relative'
      backgroundColor='white'
      borderRadius='16px'
      height='180px'
      width='100%'
      style={{boxShadow: '0px 5px 8px 0px #00000026'}}>
      <Box display='flex' direction='column' padding='24px 32px'>
        {icon}
        <Typography variant='label' size='16px' marginTop='8px' color='#667085' weight={600}>
          {title}
        </Typography>
        {refetching && !loading && (
          <Tooltip title='Buscando atualizações' placement='top'>
            <Box position='absolute' right='24px' display='flex' columnGap='8px'>
              <Loading size='20px' />
            </Box>
          </Tooltip>
        )}
        {loading ? (
          <Box display='flex' direction='row' columnGap='8px' align='flex-end' marginTop='4px'>
            <Skeleton width={'72px'} height={'44px'} borderRadius='8px' />
            <Skeleton width={'50px'} height={'16px'} borderRadius='4px' />
          </Box>
        ) : (
          <Box display='flex' direction='row' columnGap='8px' align='flex-end'>
            <Tooltip title={value !== undefined ? `${value} ${description}` : undefined} placement='top'>
              <Box>
                <Typography variant='label' size='48px' lineHeight='48px' weight={700} color='#344054'>
                  {typeof value === 'number' ? abbreviateNumber(value) : typeof value === 'undefined' ? '-' : value}
                </Typography>
              </Box>
            </Tooltip>
            <Typography
              variant='label'
              size='14px'
              color='#667085'
              style={{display: 'flex', width: '90%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
              {description}
            </Typography>
          </Box>
        )}
      </Box>
    </ResponsiveContainer>
  )
}

export default DashboardCountCard

export const ResponsiveContainer = styled(Box)`
  flex: 1;
  min-width: 250px;

  @media (max-width: 1660px) {
    height: 196px;
  }
`
